/** Dedicated Enterprise Portal — Enterprise franchise control (not salon/brand product consoles). */
export const ENTERPRISE_CONTROL_BASE = "/enterprise-portal/enterprise-control";
